import { IUser } from '~/src/dash/api/console-api';
import {
  addDomainAndTokenToUrl,
  defaultRestGetArgs,
  ResponseType,
  restGet,
} from '~/src/dash/api/rest';

export async function getUserByID(userID: number): Promise<IUser> {
  const reqUrl = addDomainAndTokenToUrl(`/user/${userID}`);
  try {
    const response = await restGet<any>(reqUrl, defaultRestGetArgs, ResponseType.json);
    return response.parsedBody;
  } catch (err) {
    throw err;
  }
}
